import { Space, Divider, Typography, Button, message, Card } from "antd";
import { useState } from "react";
import ReactJson from "react-json-view";
import { getLatestStripePayments } from "services";

const StripeTab = ({ data }: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [payments, setPayments] = useState<any>([])

  const contactId = data.user.mauticContactId;

  const handleOnGetStripe = () => {
    setLoading(true);
    getLatestStripePayments(contactId)
      .then(({ data: { payments } }: any) => setPayments(payments))
      .catch(() => message.error("Can not get the list of stripe payments"))
      .finally(() => setLoading(false))
  }

  return (
    <Space direction="vertical" size="middle" style={{ width: "100%", padding: 20, overflow: "auto" }}>
      <Divider orientation="left">
        <Typography.Title level={3}>Stripe</Typography.Title>
      </Divider>
      <Space direction="vertical" size="large">
        <Button type="primary" onClick={handleOnGetStripe} loading={loading}>List Latest 10 Stripe Payments</Button>
        {payments.length > 0 && payments.map((p: any, index: number) => (
          <Card key={`stripe-json-${index}`}>
            <ReactJson src={p} collapsed={1} />
          </Card>
        ))}
      </Space>
    </Space>
  )
}

export default StripeTab;